












import { Component, Vue } from 'vue-property-decorator'
import OperatorList from '@/components/OperatorList.vue'

@Component({
  components: {
    OperatorList
  }
})
export default class User extends Vue {}
